import ApiService from './ApiService';

export interface FeatureFlags {
    auditingEnabled: boolean;
}

export class ConfigurationService extends ApiService {

    async getFeatureFlags(): Promise<FeatureFlags> {
        const response = await this.get('/api/configuration/features');

        if (!response.ok) {
            throw new Error('Failed to fetch feature flags');
        }

        return await response.json();
    }
}